import { render, staticRenderFns } from "./FormUpdateBadge.vue?vue&type=template&id=dad48cce&scoped=true"
import script from "./FormUpdateBadge.vue?vue&type=script&lang=js"
export * from "./FormUpdateBadge.vue?vue&type=script&lang=js"
import style0 from "./FormUpdateBadge.vue?vue&type=style&index=0&id=dad48cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad48cce",
  null
  
)

export default component.exports